import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'features.maintenance.title',
    defaultMessage: 'Manutenzione in corso',
    description: 'Maintenance page title',
  },
  subtitle: {
    id: 'features.maintenance.subtitle',
    defaultMessage:
      "Il portale sarà nuovamente disponibile appena terminato l'intervento",
    description: 'Maintenance page subtitle',
  },
});
